import React, { useEffect, useState, useContext } from "react";
import "./FanBaseHome.css";
import fan from "../../../../assets/images/Fanbase-img/unsplash_sYhUhse5uT8.png";
import meme from "../../../../assets/images/Fanbase-img/meme.png";
import meme2 from "../../../../assets/images/Fanbase-img/meme2.png";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../../App";

const FanBaseHome = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  let { slug } = useParams();

  const [allFanPost, setAllFanPost] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setAllFanPost(res.data.allFanPost);
      }
    });
  }, [slug]);

  if (props.checkApproveReal) {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setAllFanPost(res.data.allFanPost);
      }
    });
  }

  return (
    <>
      <div className="container-lg">
        <div className="parent-divFan">
          <div className="child-divFan">
            {allFanPost.map((post, i) => (
              <div className="card card-bg postFancard my-4" key={i}>
                <div className="card-body">
                  <div className="d-flex">
                    <img
                      src={imageCdnUrl + post.user?.image}
                      className="img-fluid mx-2 hasImg"
                      alt=""
                    />
                    <div className=" w-75">
                      <h6 className="m-0">
                        {post.user?.first_name} {post.user?.last_name}
                      </h6>
                      <small style={{ color: "#A7A7A7" }}>
                        <span>{moment(post.created_at).format("LT")} </span>{" "}
                        <span className="mx-2">
                          {moment(post.created_at).format("LL")}
                        </span>{" "}
                        <span>{post.star_name}</span>
                      </small>
                    </div>
                  </div>

                  <div className="container my-2">
                    <p className="text-light">{post?.description}</p>
                    {post?.image || post?.video ? (
                      <>
                        {post.image ? (
                          <img
                            src={imageCdnUrl + post.image}
                            className="img-fluid w-100"
                            alt=""
                          />
                        ) : (
                          <div>
                            <center>
                              <ReactPlayer
                                className="form-control VideoPlays"
                                url={videoCdnUrl + post.video}
                                autoplay
                                controls="true"
                              />
                            </center>
                          </div>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="container my-2">
                    <button
                      className="btn text-warning btn-secondary fan-button"
                      style={{ width: "100%" }}
                    >
                      <i className="fa-solid fa-heart mx-1"></i>
                      {JSON.parse(post.user_like_id).length} Likes
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FanBaseHome;
